import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { NgxBootstrapIconsModule } from 'ngx-bootstrap-icons';
import { DirectivesModule } from 'src/app/ui/directives/directives.module';

import { DocumentFileCellModule } from '../document-file-cell/document-file-cell.module';
import { SharedDocumentUploadModalComponent } from './shared-document-upload-modal.component';

@NgModule({
  declarations: [SharedDocumentUploadModalComponent],
  imports: [
    CommonModule,
    DirectivesModule,
    DocumentFileCellModule,
    NgxBootstrapIconsModule,
    BsDropdownModule,
    BsDatepickerModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  exports: [SharedDocumentUploadModalComponent],
})
export class SharedDocumentUploadModalModule {}
